// extracted by mini-css-extract-plugin
module.exports = {"partnerPaymentsContainer":"PartnerPaymentsContainer_partnerPaymentsContainer__b843X"};